import { useEffect, useState } from 'react'

import AsyncStorage from '@react-native-async-storage/async-storage'

import { IS_WEB, LYRA_AURORA_THEME_STORAGE_KEY } from '../constants'

const DEFAULT_FALSE_STR = 'false'

/**
 * This hook is a temporary storage solution for the Aurora theme color using local storage used for DevTool. This
 * is an override to enable Aurora theme colors for basic UI testing, and does not enable Aurora features.
 * This should be removed with the feature flag `isAuroraEnabled` after release
 **/
export const useAuroraThemeSettings = () => {
  const [isAuroraTheme, setIsAuroraTheme] = useState<boolean>(false)

  useEffect(() => {
    if (IS_WEB) {
      setIsAuroraTheme(JSON.parse(localStorage.getItem(LYRA_AURORA_THEME_STORAGE_KEY) || DEFAULT_FALSE_STR))
    } else {
      const getAuroraAsyncStorage = async () => {
        const mobileIsAuroraTheme = await AsyncStorage.getItem(LYRA_AURORA_THEME_STORAGE_KEY)
        const parsedIsAuroraTheme: boolean = JSON.parse(mobileIsAuroraTheme || DEFAULT_FALSE_STR)
        setIsAuroraTheme(parsedIsAuroraTheme)
      }

      getAuroraAsyncStorage()
    }
  }, [])

  const toggleIsAuroraTheme = () => {
    const updatedIsAuroraThemeEnabled = !isAuroraTheme
    if (IS_WEB) {
      localStorage.setItem(LYRA_AURORA_THEME_STORAGE_KEY, JSON.stringify(updatedIsAuroraThemeEnabled))
    } else {
      const setAuroraAsyncStorage = async () => {
        await AsyncStorage.setItem(LYRA_AURORA_THEME_STORAGE_KEY, JSON.stringify(updatedIsAuroraThemeEnabled))
      }

      setAuroraAsyncStorage()
    }
    setIsAuroraTheme(updatedIsAuroraThemeEnabled)
  }

  return { isAuroraThemeEnabled: isAuroraTheme, toggleIsAuroraTheme }
}
